module.exports = __webpack_public_path__ + "assets/img/a82ee56d1724d7d6089ac5704961078c.svg";